<rask-page
    pageTitle="Sök användare"
    noPadding>
    <ng-container headerContent>

        <form [formGroup]="searchForm" (ngSubmit)="search()">
            @if(searchForm.touched && searchForm.errors?.atLeastOneRequired) {
            <rask-validation-message-row
                type="error"
                message=" Minst ett sökfält måste vara ifyllt.">
            </rask-validation-message-row>
            }
            <div class="row">
                <rask-input
                    class="col-1"
                    id="anvandareId"
                    label="Användar-id"
                    formControlName="userid">
                </rask-input>
                <rask-input
                    class="col-2"
                    id="anvandareFornamn"
                    label="Förnamn"
                    formControlName="firstname">
                </rask-input>
                <rask-input
                    class="col-2"
                    id="anvandareEfternamn"
                    label="Efternamn"
                    formControlName="lastname">
                </rask-input>
                <rask-input
                    class="col-2"
                    id="anvandarMail"
                    label="E-Post"
                    formControlName="mail">
                </rask-input>
                <div class="col">
                    <rask-submit-button
                        aid="buttonSok"
                        color="secondary">
                        Sök
                    </rask-submit-button>
                </div>
            </div>
        </form>
    </ng-container>
    <rask-anvandare-list [anvandare]="anvandare"></rask-anvandare-list>
</rask-page>